import { StyleSheet, Dimensions } from "react-native";
import colors from "@constants/color";

const { width: screenWidth, height: screenHeight } = Dimensions.get("screen");

const styles = StyleSheet.create({
  btnStyle: {
    borderRadius: 12,
    backgroundColor: colors.primary,
    paddingVertical: 14,
    width: 300,
  },
  btnContainertyle: {
    marginTop: 40,
    marginBottom: 70,
    alignItems: "center",
  },
  textContainer: {
    marginTop: 30,
    justifyContent: "center",
    alignItems: "center",
  },
  imgStyle: {
    width: screenWidth,
    height: undefined,
    aspectRatio: 360 / 204,
  },
  mainContentContainer: {
    marginTop: "auto",
    justifyContent: "center",
    alignItems: "center",
  },
});

export default styles;
